export default [
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/cadastro-trial',
    name: 'cadastro-trial',
    component: () => import('@/views/Login/Cadastro.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      requiresAuth: false,
    },
  },
  {
    path: '/primeiro-acesso',
    name: 'primeiro-acesso',
    component: () => import('@/views/Login/PrimeiroAcesso.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      requiresAuth: false,
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    },
  },
  {
    path: '/loginBrc',
    name: 'auth-login-brc',
    component: () => import('@/views/Login/LoginBRC.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    },
  },
  {
    path: '/cadastro',
    name: 'cadastro',
    component: () => import('@/views/Usuario/CadastroUsuario.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: false,
    },
  },

  {
    path: '/perfil',
    name: 'perfil_usuario',
    component: () => import('@/views/Usuario/perfil-Usuario/Index.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Perfil',
      breadcrumb: [
        {
          text: 'Perfil',
          active: true,

        },
      ],
    },
  },
  {
    path: '/academy/:userId/:studentKey',
    name: 'academy-student',
    component: () => import('@/views/App/Treinamentos/AcademyStudent.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      requiresAuth: false,
    },
  },

]
